import { useTopNewsQuery } from "@graphql/generated/graphql";
import { errorToastPopup } from "@lib/errorToastPopup";
import { Trans } from "@lingui/macro";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useMemo } from "react";

const SideBarTopNews = () => {
  const {
    query: { id },
    pathname,
    locale,
  } = useRouter();

  const { data, loading, refetch, error } = useTopNewsQuery({
    variables: { languageCode: locale },
  });

  const topNews = useMemo(() => {
    if (loading || !data.topNews) {
      return [];
    }

    if (pathname === "/news/[id]") {
      return data.topNews.filter((news) => news.id != id);
    } else {
      return data.topNews;
    }
  }, [data, id, loading, pathname]);

  useEffect(() => {
    refetch({ languageCode: locale });
  }, [locale, refetch]);

  useEffect(() => {
    if (error) {
      errorToastPopup(error);
    }
  }, [error]);

  return (
    <div className="lg:max-w-[390px]">
      <p className="pb-4 font-poppins text-lg font-bold text-text-darkest">
        <Trans>What's Hot This Hour</Trans>
      </p>
      <div className="space-y-2">
        {topNews.map(({ id, title, newsPublisher }, index) => {
          return (
            <>
              <div className="flex flex-row space-x-4">
                <div className="text-md ml-4 flex h-[40px] w-[40px] items-center justify-center rounded-full bg-light-background px-4 font-sen text-text-darkest lg:ml-0">
                  {index + 1}
                </div>

                <div>
                  <Link href={`/publishers/${newsPublisher.slug}`} passHref>
                    <p className="font-sen text-sm text-text-lightest hover:cursor-pointer hover:text-text-dark">
                      {newsPublisher.name}
                    </p>
                  </Link>
                  <Link href={`/news/${id}`} passHref>
                    <p className="font-poppins font-bold text-text-dark hover:cursor-pointer hover:text-text-darkest">
                      {title}
                    </p>
                  </Link>
                </div>
                <div></div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default SideBarTopNews;
